import {v4 as uuidv4} from "uuid";
import * as firebase from "firebase";
import {PrintableCalendarFonts} from "@/consts/PrintableCalendarFonts";
import {PrintableCalendarFontSizes} from "@/consts/PrintableCalendarFontSizes";
import GalleryPhotosUploadDlg from "@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue";
import {optimizePhotos} from "@/utils/upload-image";
import {fileSizeToMB, validFileSize10MB} from "@/utils/fileSizeToMB";
import {PrintableCalendarDimensionColor} from "@/consts/PrintableCalendarDimensionColor";
import {DimensionColorTypes} from "@/consts/PrintableCalendarDimensionColor";
import {GalleryImage} from "@/models/GalleryImage";

export default {
  name: "PrintableCalendarSettings",
  data() {
    return {
      file: "",
      preview: "",
      formats: ["image/png", "image/jpg", "image/jpeg"],
      loading: false,
      disabled: true,
      color: "",
      borderColor: "",
      isUploadGalleryPhoto: false,
      isChangePhoto: false,
      isChangeColor: false,
      isChangeBorderColor: false,
      isRemovePhoto: false,
      isChangeHeader: false,
      isChangeBody: false,
      isChangedBorderForWing: false,
      isChangePrintableCalendarBodyFontSize: false,
      isChangePrintableCalendarHeaderFontSize: false,
      isChangePrintableCalendarHeaderFontColor: false,
      isChangePrintableCalendarHideLocationKeysSize: false,
      isChangePrintableCalendarHideLocationKeys: false,
      isChangePrintableCalendarInputCustomBoxColor: false,
      colorMenu: false,
      colorBorderMenu: false,
      printableCalendarHeaderFont: '',
      printableCalendarHeaderFontColor: '',
      printableCalendarHeaderFontSize: '',
      printableCalendarInputCustomBoxColor: '',
      printableCalendarInputCustomBoxSize: '',
      printableCalendarBodyFont: '',
      printableCalendarBodyFontSize: '',
      printableCalendarHideLocationKeys: true,
      printableCalendarLocationKeysFontSize: '',
      isHaveDifferentBorderPerWing: false,
      isChangedDimensionColor: false,
      isDimensionColor: false,
      isChangedUseWingsCustomName: false,
      isChangedUseWingsCustomNameDescription: false,
      isUseWingsCustomName: false,

      isChangedFacilityCustomName: false,
      isChangedUseFacilityCustomName: false,
      isUseFacilityCustomName: false,

      wingId: null,
      isChangedDimensionColorType: false,
      selectedDimensionColorType: '',
      isChangedWeekdays: false,
      previewCustomImage: "",
      fileCustomImage: "",
      isUploadGalleryCustomImage: false,
      isChangeCustomImage: false,
      isRemovePhotoCustomImage: false,
      isChangedCustomImageSize: false,
      selectedMode: "",
      selectedImage: null,
      isChangedCompactMode: false,
      colorHeaderFontMenu: false,
      colorCustomTextBoxMenu: false,
      backgroundColorDatesMenu: false,
      colorDatesMenu: false,
      isChangePrintableCalendarDatesBackgroundColor: false,
      printableCalendarDatesBackgroundColor: '',
      isChangePrintableCalendarDatesColor: false,
      printableCalendarDatesColor: '',
      isUploadGalleryDecorImage: false,
      isChangeDecorImage: false,
      isRemovePhotoDecorImage: false,
      previewDecorImage: "",
      fileDecorImage: "",
      isChangedDecorImageSize: false,
      isChangedLogoSize: false,
      isChangedConciergeEvents: false,
      isChangedShowEndTime: false,
      isChangedDatePositionRight: false,
      isChangedDisplayAMPM: false,
      isChangedLocationsHeaderSize: false,
      isChangedCustomTextBoxColor: false,
      isChangedCustomTextBoxSize: false,
      isChangedCalendarDescription: false,
      isChangedImages: false,
      isUploadedImages: false,
      isRemoveImages: false,
      isChangedImagesPositions: false,
      isChangedTextBoxes: false,
    }
  },
  props: {
    selectedWingsPrintableCalendar: {
      type: Array
    },
    wingsCustomNameDescription: {
      type: String
    },
    facilityCustomName: {
      type: String
    },
    weekdays: {
      type: Array
    },
    isCompactMode: {
      type: Boolean
    },
    locationsSize: {
      type: Object
    },
    decorImageSize: {
      type: Object
    },
    logoSize: {
      type: Object
    },
    customPhotoSize: {
      type: Object
    },
    isShowConciergeEvents: {
      type: Boolean
    },
    isShowEndTime: {
      type: Boolean
    },
    isDatePositionRight: {
      type: Boolean
    },
    isDisplayAMPM: {
      type: Boolean
    },
    locationsSizeHeader: {
      type: Object
    },
    customTextBoxSizeHeader: {
      type: Object
    },
    calendarDescription: {
      type: String
    },
    printableCalendarImages: {
      type: Array
    },
    printableCalendarTextBoxes: {
      type: Array
    },
    pagination: {
      type: Object
    },
    is2Weeks: {
      type: Boolean
    },
    isPrintCalendar: {
      type: Boolean
    }
  },
  components: {
    GalleryPhotosUploadDlg
  },
  async mounted() {
    await this.$store.dispatch("getEventWings")
    this.checkFacilityPrintableCalendarSettings();
    this.checkFacilityPrintableCalendarFonts();
    this.checkFacilityHaveDifferentBorderPerWing();
    this.checkFacilityDimensionColor();
    this.checkFacilityDimensionColorType();
    this.checkFacilityWingsCustomName();
    this.checkFacilityCustomName();
  },
  computed: {
    facilityId() {
      return this.$store.state.authModule.currentFacility;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    swatchStyle() {
      return {
        backgroundColor: this.color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    borderStyle() {
      return {
        backgroundColor: this.borderColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    headerFontSwatchStyle() {
      return {
        backgroundColor: this.printableCalendarHeaderFontColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    datesSwatchStyle() {
      return {
        backgroundColor: this.printableCalendarDatesBackgroundColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    datesColorStyle() {
      return {
        backgroundColor: this.printableCalendarDatesColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    printableCalendarFonts() {
      return Object.values(PrintableCalendarFonts);
    },
    printableCalendarFontSizes() {
      return Object.values(PrintableCalendarFontSizes)
    },
    wings() {
      return this.$store.state.eventLocationModule.eventWings;
    },
    isAllWings() {
      return this.wings.length === this.selectedWingsPrintableCalendar?.length;
    },
    printableCalendarDimensionColor() {
      return PrintableCalendarDimensionColor;
    },
    calendarPages() {
      const pages = this.pagination.pages;
      const result: any = [{
        page: 'all',
        pageName: "All pages"
      }];

      for(let i = 1; i <= pages; i++) {
        result.push({
          page: i,
          pageName: `Page ${i}`
        })
      }

      return result;
    },
    calendarCount() {
      return [
        {
          week: 'all',
          weekName: "All Weeks"
        },
        {
          week: 1,
          weekName: "Week 1"
        },
        {
          week: 2,
          weekName: "Week 2"
        }
      ]
    }
  },
  methods: {
    async updatePrintableCalendar() {
      this.loading = true;
      const facilityUpdates: any = {}

      if(this.isUploadGalleryPhoto) {
        if(this.isHaveDifferentBorderPerWing && !this.isAllWings && this.selectedWingsPrintableCalendar.length !== 0) {
          for(let i = 0; i < this.selectedWingsPrintableCalendar.length; i++) {
            const wingId = this.selectedWingsPrintableCalendar[i].id;

            await firebase
              .firestore()
              .collection("eventLocations")
              .doc(wingId)
              .update({
                backgroundImage: this.preview
              })
          }

          await this.$store.dispatch("getEventWings")
          this.loading = false;

        } else {
          firebase
            .firestore()
            .collection("facility")
            .doc(this.facilityId)
            .update({
              printableCalendarUrl: this.preview
            })
            .then(async () => {
              await this.$store.dispatch("getFacility");
              await this.$store.dispatch("getEventWings");
              this.loading = false;
            });
        }
      }

      if(this.isChangePhoto) {
        const ref = uuidv4();
        const file: Blob | File | any = await optimizePhotos(this.file, '');
        const fileSizeInMegabytes = fileSizeToMB(file?.size);

        if (!validFileSize10MB(fileSizeInMegabytes)) {
          this.$refs.inputUpload.value = null;
          return;
        }

        if(file) {
          const storageRef = firebase
            .storage()
            .ref()
            .child(this.facilityId)
            .child("printableCalendar")
            .child(ref)
            .put(file);

          storageRef.on(
            `state_changed`,
            snapshot => {
              console.log("uploading...")
            },
            error => {
              console.error(error.message);
            },
            () => {
              storageRef.snapshot.ref.getDownloadURL().then(async url => {
                if(this.isHaveDifferentBorderPerWing && !this.isAllWings) {
                  for(let i = 0; i < this.selectedWingsPrintableCalendar.length; i++) {
                    const wingId = this.selectedWingsPrintableCalendar[i].id;

                    await firebase
                      .firestore()
                      .collection("eventLocations")
                      .doc(wingId)
                      .update({
                        backgroundImage: url
                      })
                  }

                  await this.$store.dispatch("getEventWings")
                  this.file = '';
                  this.loading = false;

                  const fileInput: any = document.getElementById('fileInput');
                  fileInput.value = "";
                } else {
                  firebase
                    .firestore()
                    .collection("facility")
                    .doc(this.facilityId)
                    .update({
                      printableCalendarUrl: url
                    })
                    .then(async () => {
                      await this.$store.dispatch("getFacility");
                      await this.$store.dispatch("getEventWings");
                      this.file = '';
                      this.loading = false;
                    });
                }
              });
            }
          );
        }
      }

      if(this.isChangeCustomImage) {
        const ref = uuidv4();
        const file: Blob | File | any = await optimizePhotos(this.fileCustomImage, '');
        const fileSizeInMegabytes = fileSizeToMB(file?.size);

        if (!validFileSize10MB(fileSizeInMegabytes)) {
          this.$refs.inputUploadCustomImage.value = null;
          return;
        }

        if(file) {
          const storageRef = firebase
            .storage()
            .ref()
            .child(this.facilityId)
            .child("printableCalendar")
            .child(ref)
            .put(file);

          storageRef.on(
            `state_changed`,
            snapshot => {
              console.log("uploading...")
            },
            error => {
              console.error(error.message);
            },
            () => {
              storageRef.snapshot.ref.getDownloadURL().then(async url => {
                firebase
                  .firestore()
                  .collection("facility")
                  .doc(this.facilityId)
                  .update({
                    printableCalendarCustomImage: url
                  })
                  .then(async () => {
                    await this.$store.dispatch("getFacility");
                    this.fileCustomImage = '';
                    this.loading = false;
                  });
              });
            }
          );
        }
      }

      if(this.isChangeDecorImage) {
        const ref = uuidv4();
        const file: Blob | File | any = await optimizePhotos(this.fileDecorImage, '');
        const fileSizeInMegabytes = fileSizeToMB(file?.size);

        if (!validFileSize10MB(fileSizeInMegabytes)) {
          this.$refs.inputUploadDecorImage.value = null;
          return;
        }

        if(file) {
          const storageRef = firebase
            .storage()
            .ref()
            .child(this.facilityId)
            .child("printableCalendar")
            .child(ref)
            .put(file);

          storageRef.on(
            `state_changed`,
            snapshot => {
              console.log("uploading...")
            },
            error => {
              console.error(error.message);
            },
            () => {
              storageRef.snapshot.ref.getDownloadURL().then(async url => {
                firebase
                  .firestore()
                  .collection("facility")
                  .doc(this.facilityId)
                  .update({
                    printableCalendarDecorImage: url
                  })
                  .then(async () => {
                    await this.$store.dispatch("getFacility");
                    this.fileDecorImage = '';
                    this.loading = false;
                  });
              });
            }
          );
        }
      }

      if (this.isChangedImages) {
        for (let i = 0; i < this.printableCalendarImages.length; i++) {
          const image = this.printableCalendarImages[i];

          if (image.file) {
            const ref = uuidv4();
            const file = await optimizePhotos(image.file, '');
            const fileSizeInMegabytes = fileSizeToMB(file?.size);

            if (!validFileSize10MB(fileSizeInMegabytes)) {
              const refName = `image${this.selectedImage}`;
              const inputRef = this.$refs[refName];
              if (inputRef[0]) {
                inputRef[0].value = null;
              }

              return;
            }

            if (file) {
              const storageRef = firebase
                .storage()
                .ref()
                .child(this.facilityId)
                .child("printableCalendar")
                .child(ref)
                .put(file);

              await new Promise((resolve, reject) => {
                storageRef.on(
                  `state_changed`,
                  snapshot => {
                    console.log("uploading...");
                  },
                  error => {
                    console.error(error.message);
                    reject(error);
                  },
                  () => {
                    storageRef.snapshot.ref.getDownloadURL().then(async url => {
                      this.printableCalendarImages[i].url = url;
                      resolve();
                    }).catch(error => {
                      console.error(error.message);
                      reject(error);
                    });
                  }
                );
              });
            }
          }
        }

        this.mapPrintableCalendarImages();

        await firebase
          .firestore()
          .collection("facility")
          .doc(this.facilityId)
          .update({
            printableCalendarImages: this.printableCalendarImages
          });

        await this.$store.dispatch("getFacility");
        this.loading = false;
      }

      if(this.isUploadedImages) {
        this.mapPrintableCalendarImages();
        facilityUpdates.printableCalendarImages = this.printableCalendarImages;
      }

      if(this.isRemoveImages) {
        facilityUpdates.printableCalendarImages = this.printableCalendarImages;
      }

      if(this.isChangedImagesPositions) {
        this.mapPrintableCalendarImages();
        facilityUpdates.printableCalendarImages = this.printableCalendarImages;
      }

      if(this.isChangedTextBoxes) {
        facilityUpdates.printableCalendarTextBoxes = this.printableCalendarTextBoxes;
      }

      if(this.isRemovePhoto) {
        if(this.isHaveDifferentBorderPerWing && !this.isAllWings && this.selectedWingsPrintableCalendar.length !== 0) {
          for(let i = 0; i < this.selectedWingsPrintableCalendar.length; i++) {
            const wingId = this.selectedWingsPrintableCalendar[i].id;

            await firebase
              .firestore()
              .collection("eventLocations")
              .doc(wingId)
              .update({
                backgroundImage: ""
              })
          }

          await this.$store.dispatch("getEventWings")
          this.loading = false;
        } else {
          firebase
            .firestore()
            .collection('facility')
            .doc(this.facilityId)
            .update({
              printableCalendarUrl: ""
            })
            .then(async () => {
              await this.$store.dispatch("getFacility");
              this.loading = false;
            })
        }
      }

      if(this.isUploadGalleryCustomImage) {
        facilityUpdates.printableCalendarCustomImage = this.previewCustomImage;
      }

      if(this.isUploadGalleryDecorImage) {
        facilityUpdates.printableCalendarDecorImage = this.previewDecorImage;
      }

      if(this.isChangeColor) {
        facilityUpdates.printableCalendarColor = this.color;
      }

      if(this.isChangeBorderColor) {
        facilityUpdates.printableCalendarBorderColor = this.borderColor;
      }

      if(this.isRemovePhotoCustomImage) {
        facilityUpdates.printableCalendarCustomImage = "";
      }

      if(this.isRemovePhotoDecorImage) {
        facilityUpdates.printableCalendarDecorImage = "";
      }

      if(this.isChangeHeader) {
        facilityUpdates.printableCalendarHeaderFont = this.printableCalendarHeaderFont;
      }

      if(this.isChangePrintableCalendarHeaderFontColor) {
        facilityUpdates.printableCalendarHeaderFontColor = this.printableCalendarHeaderFontColor;
      }

      if(this.isChangePrintableCalendarHeaderFontSize) {
        facilityUpdates.printableCalendarHeaderFontSize = this.printableCalendarHeaderFontSize;
      }

      if(this.isChangeBody) {
        facilityUpdates.printableCalendarBodyFont = this.printableCalendarBodyFont;
      }

      if(this.isChangePrintableCalendarBodyFontSize) {
        facilityUpdates.printableCalendarBodyFontSize = this.printableCalendarBodyFontSize;
      }

      if(this.isChangedBorderForWing) {
        facilityUpdates.isHaveDifferentBorderPerWing = this.isHaveDifferentBorderPerWing;
        facilityUpdates.lastWingWithBorder = this.wingId;
      }

      if(this.isChangePrintableCalendarLocationKeysSize) {
        facilityUpdates.printableCalendarLocationKeysFontSize = this.printableCalendarLocationKeysFontSize;
      }

      if(this.isChangePrintableCalendarHideLocationKeys) {
        facilityUpdates.printableCalendarHideLocationKeys = this.printableCalendarHideLocationKeys;
      }

      if(this.isChangedCustomTextBoxSize) {
        facilityUpdates.printableCalendarInputCustomBoxSize = this.printableCalendarInputCustomBoxSize;
      }

      if(this.isChangePrintableCalendarDatesBackgroundColor) {
        facilityUpdates.printableCalendarDatesBackgroundColor = this.printableCalendarDatesBackgroundColor;
      }

      if(this.isChangePrintableCalendarDatesColor) {
        facilityUpdates.printableCalendarDatesColor = this.printableCalendarDatesColor;
      }

      if(this.isChangedDimensionColor) {
        facilityUpdates.isDimensionColor = this.isDimensionColor;
      }

      if(this.isChangedDimensionColorType) {
        facilityUpdates.selectedDimensionColorType = this.selectedDimensionColorType;
      }

      if(this.isChangedUseWingsCustomName) {
        facilityUpdates.isUseWingsCustomName = this.isUseWingsCustomName;
      }

      if(this.isChangedUseWingsCustomNameDescription) {
        facilityUpdates.wingsCustomNameDescription = this.wingsCustomNameDescription;
      }

      if(this.isChangedUseFacilityCustomName) {
        facilityUpdates.isUseFacilityCustomName = this.isUseFacilityCustomName;
      }

      if(this.isChangedFacilityCustomName) {
        facilityUpdates.facilityCustomName = this.facilityCustomName;
      }

      if(this.isChangedWeekdays) {
        facilityUpdates.printableCalendarWeekdays = this.weekdays;
      }

      if(this.isChangedCompactMode) {
        facilityUpdates.printableCalendarCompactMode = this.isCompactMode;
      }

      if(this.isChangedLocationsHeaderSize) {
        facilityUpdates.printableCalendarLocationsSizeHeader = this.locationsSizeHeader;
      }

      if(this.isChangedDecorImageSize) {
        facilityUpdates.printableCalendarDecorImageSize = this.decorImageSize;
      }

      if(this.isChangedLogoSize) {
        facilityUpdates.printableCalendarLogoSize = this.logoSize;
      }

      if(this.isChangedCustomImageSize) {
        facilityUpdates.printableCalendarCustomImageSize = this.customPhotoSize;
      }

      if(this.isChangedConciergeEvents) {
        facilityUpdates.printableCalendarConciergeEvents = this.isShowConciergeEvents;
      }

      if(this.isChangedShowEndTime) {
        facilityUpdates.printableCalendarShowEndTime = this.isShowEndTime;
      }

      if(this.isChangedDatePositionRight) {
        facilityUpdates.printableCalendarDatePositionRight = this.isDatePositionRight;
      }

      if(this.isChangedDisplayAMPM) {
        facilityUpdates.printableCalendarDisplayAMPM = this.isDisplayAMPM;
      }

      if(this.isChangedCustomTextBoxColor) {
        facilityUpdates.printableCalendarCustomTextBoxSizeHeader = this.customTextBoxSizeHeader;
      }

      if(this.isChangePrintableCalendarInputCustomBoxColor) {
        facilityUpdates.printableCalendarInputCustomBoxColor = this.printableCalendarInputCustomBoxColor;
      }

      if(this.isChangedCalendarDescription) {
        facilityUpdates.calendarDescription = this.calendarDescription;
      }

      if(Object.keys(facilityUpdates).length) {
        firebase
          .firestore()
          .collection("facility")
          .doc(this.facilityId)
          .update(facilityUpdates)
          .then(async () => {
            await this.$store.dispatch("getFacility");
            this.loading = false;
          });
      }

      this.$emit('addAbilityToExport');

      this.resetSettingsParams();

      this.disabled = true;
    },
    uploadPhoto(event) {
      const file = event.target.files[0]
      if(!this.formats.includes(file.type)) {
        return false;
      }

      this.file = file;
      this.preview = URL.createObjectURL(event.target.files[0]);
      this.$emit('changeBackgroundImage', URL.createObjectURL(event.target.files[0]))
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangePhoto = true;
      this.isUploadGalleryPhoto = false;
    },
    uploadPhotoCustomImage(event) {
      const file = event.target.files[0]
      if(!this.formats.includes(file.type)) {
        return false;
      }

      this.fileCustomImage = file;
      this.previewCustomImage = URL.createObjectURL(event.target.files[0]);
      this.$emit('changeCustomImage', URL.createObjectURL(event.target.files[0]))
      this.removeAbilityToExport();
      this.disabled = false;

      this.isChangeCustomImage = true;
      this.isUploadGalleryCustomImage = false;
    },
    uploadPhotoDecorImage(event) {
      const file = event.target.files[0]
      if(!this.formats.includes(file.type)) {
        return false;
      }

      this.fileDecorImage = file;
      this.previewDecorImage = URL.createObjectURL(event.target.files[0]);
      this.$emit('changeDecorImage', URL.createObjectURL(event.target.files[0]))
      this.removeAbilityToExport();
      this.disabled = false;

      this.isChangeDecorImage = true;
      this.isUploadGalleryDecorImage = false;
    },
    uploadImage(event, index) {
      this.selectedImage = index;
      const file = event.target.files[0]
      if(!this.formats.includes(file.type)) {
        return false;
      }

      const blob = new Blob([event.target.files[0]]);
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.src = url;

      img.onload = () => {
        this.printableCalendarImages[index].file = file;
        this.printableCalendarImages[index].url = URL.createObjectURL(event.target.files[0]);
        this.$emit('changeImage', {
          index: index,
          url: URL.createObjectURL(event.target.files[0]),
          width: img.width / 3,
          height: img.height / 3
        });

        this.removeAbilityToExport();
        this.disabled = false;

        this.isChangedImages = true;
        this.isUploadedImages = false;
      }
    },
    checkFacilityPrintableCalendarSettings() {
      this.preview = this.facility.printableCalendarUrl ? this.facility.printableCalendarUrl : '';
      this.previewCustomImage = this.facility.printableCalendarCustomImage ? this.facility.printableCalendarCustomImage : '';
      this.previewDecorImage = this.facility.printableCalendarDecorImage ? this.facility.printableCalendarDecorImage : '';
      this.color = this.facility.printableCalendarColor ? this.facility.printableCalendarColor : '#ffffff';
      this.borderColor = this.facility.printableCalendarBorderColor ? this.facility.printableCalendarBorderColor : '#3f51b5';
    },
    updateBackgroundColor(color) {
      this.color = color;
      this.$emit('changeBackgroundColor', color);
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangeColor = true;
    },
    updateBorderColor(color) {
      this.borderColor = color;
      this.$emit('changeBorderColor', color);
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangeBorderColor = true;
    },
    updateDatesBackgroundColor(color) {
      this.printableCalendarDatesBackgroundColor = color;
      this.$emit('changeDatesBackgroundColor', color);
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangePrintableCalendarDatesBackgroundColor = true;
    },
    updateDatesColor(color) {
      this.printableCalendarDatesColor = color;
      this.$emit('changeDatesColor', color);
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangePrintableCalendarDatesColor = true;
    },
    updateHeaderFontColor(color) {
      this.printableCalendarHeaderFontColor = color;
      this.$emit('changeHeaderFontColor', color);
      this.removeAbilityToExport();
      this.disabled = false;
      this.isChangePrintableCalendarHeaderFontColor = true;
    },
    openGalleryPhotos(value: string, index: number) {
      this.selectedMode = value;
      this.selectedImage = index;
      (this.$refs.GalleryPhotosUploadDlg as any).open();
    },
    uploadGalleryPhoto(image: GalleryImage) {

      if(this.selectedMode === "border") {
        this.preview = image.image;
        this.$emit("changeBackgroundImage", image.image);
        this.removeAbilityToExport();
        this.isUploadGalleryPhoto = true;
        this.isChangePhoto = false;
        this.isUploadGalleryCustomImage = false;
        this.isChangeCustomImage = false;
        this.isUploadGalleryDecorImage = false;
        this.isChangeDecorImage = false;
        this.isChangedImages = false;
        this.isUploadedImages = false;
        this.disabled = false;
      }

      if(this.selectedMode === "customImage") {
        this.previewCustomImage = image.image;
        this.$emit("changeCustomImage", image.image);
        this.removeAbilityToExport();
        this.isUploadGalleryCustomImage = true;

        this.isChangeCustomImage = false;
        this.isUploadGalleryPhoto = false;
        this.isChangePhoto = false;
        this.isUploadGalleryDecorImage = false;
        this.isChangeDecorImage = false;
        this.isChangedImages = false;
        this.isUploadedImages = false;
        this.disabled = false;
      }

      if(this.selectedMode === "decorImage") {
        this.previewDecorImage = image.image;
        this.$emit("changeDecorImage", image.image);
        this.removeAbilityToExport();
        this.isUploadGalleryDecorImage = true;

        this.isChangeDecorImage = false;
        this.isUploadGalleryCustomImage = false;
        this.isChangeCustomImage = false;
        this.isUploadGalleryPhoto = false;
        this.isChangePhoto = false;
        this.isChangedImages = false;
        this.isUploadedImages = false;
        this.disabled = false;
      }

      if(this.selectedMode === "images") {
        const img = new Image();
        img.src = image.image;

        img.onload = () => {
          this.printableCalendarImages[this.selectedImage].url = image.image;
          this.$emit('changeImage', {
            index: this.selectedImage,
            url: image.image,
            width: img.width / 3,
            height: img.height / 3
          });
          this.removeAbilityToExport();

          this.isUploadedImages = true;
          this.isChangedImages = false;
          this.isChangeDecorImage = false;
          this.isUploadGalleryCustomImage = false;
          this.isChangeCustomImage = false;
          this.isUploadGalleryPhoto = false;
          this.isChangePhoto = false;
          this.disabled = false;
        }
      }
    },
    removeBorder(value: string, index: number) {
      if(value === "border") {
        this.preview = "";
        this.$emit("changeBackgroundImage", "");
        this.removeAbilityToExport();
        this.disabled = false;
        this.isRemovePhoto = true;
        this.isChangePhoto = false;
        this.$refs.inputUpload.value = null;
      }

      if(value === "customImage") {
        this.previewCustomImage = "";
        this.$emit("changeCustomImage", "");
        this.removeAbilityToExport();
        this.disabled = false;
        this.isRemovePhotoCustomImage = true;
        this.isChangeCustomImage = false;
        this.$refs.inputUploadCustomImage.value = null;
      }

      if(value === "decorImage") {
        this.previewDecorImage = "";
        this.$emit("changeDecorImage", "");
        this.removeAbilityToExport();
        this.disabled = false;
        this.isRemovePhotoDecorImage = true;
        this.isChangeDecorImage = false;
        this.$refs.inputUploadDecorImage.value = null;
      }

      if(value === "images") {
        this.$emit("removeImage", index);
        this.removeAbilityToExport();
        this.disabled = false;
        this.isRemoveImages = true;
        this.isChangedImages = false;

/*        const refName = `image${index}`;
        const inputRef = this.$refs[refName];
        if (inputRef[0]) {
          inputRef[0].value = null;
        }*/
      }
    },
    removeCustomImage(index) {
      this.printableCalendarTextBoxes.splice(index, 1)
    },
    checkFacilityPrintableCalendarFonts() {
      this.printableCalendarHeaderFont = this.facility?.printableCalendarHeaderFont || PrintableCalendarFonts.MrsEavesBold;
      this.printableCalendarHeaderFontSize = this.facility?.printableCalendarHeaderFontSize || PrintableCalendarFontSizes.fontSize24;
      this.printableCalendarHeaderFontColor = this.facility?.printableCalendarHeaderFontColor || "#000000";
      this.printableCalendarInputCustomBoxColor = this.facility?.printableCalendarInputCustomBoxColor || "#000000";
      this.printableCalendarInputCustomBoxSize = this.facility?.printableCalendarInputCustomBoxSize || PrintableCalendarFontSizes.fontSize12;

      this.printableCalendarBodyFont = this.facility?.printableCalendarBodyFont || PrintableCalendarFonts.ProximaNovaRegular;
      this.printableCalendarBodyFontSize = this.facility?.printableCalendarBodyFontSize || PrintableCalendarFontSizes.fontSize12;

      this.printableCalendarLocationKeysFontSize = this.facility?.printableCalendarLocationKeysFontSize || PrintableCalendarFontSizes.fontSize12;
      this.printableCalendarHideLocationKeys = this.facility?.hasOwnProperty('printableCalendarHideLocationKeys') ? this.facility?.printableCalendarHideLocationKeys : false;

      this.printableCalendarDatesBackgroundColor = this.facility?.printableCalendarDatesBackgroundColor || "#ffffff";
      this.printableCalendarDatesColor = this.facility?.printableCalendarDatesColor || "#000000";
    },
    async checkFacilityHaveDifferentBorderPerWing() {
      this.isHaveDifferentBorderPerWing = this.facility?.isHaveDifferentBorderPerWing || false;
      this.wingId = this.facility?.lastWingWithBorder || null;

      if(this.isHaveDifferentBorderPerWing) {
        this.changeWing();
      }
    },
    async checkFacilityDimensionColor() {
      this.isDimensionColor = this.facility?.isDimensionColor || false;

      if(this.isDimensionColor) {
        this.$emit('changeDisplayDimensionColor', this.isDimensionColor);
      }
    },
    async checkFacilityDimensionColorType() {
      this.selectedDimensionColorType = this.facility?.selectedDimensionColorType || DimensionColorTypes.bar;

      if(this.selectedDimensionColorType) {
        this.$emit('changeDimensionColorType', this.selectedDimensionColorType);
      }
    },
    async checkFacilityWingsCustomName() {
      this.isUseWingsCustomName = this.facility?.isUseWingsCustomName || false;

      if(this.isUseWingsCustomName) {
        this.$emit('changeDisplayWingsCustomName', this.isUseWingsCustomName);
      }
    },
    async checkFacilityCustomName() {
      this.isUseFacilityCustomName = this.facility?.isUseFacilityCustomName || false;

      if(this.isUseFacilityCustomName) {
        this.$emit('changeFacilityCustomName', this.isUseFacilityCustomName);
      }
    },
    changeWing() {
      if(this.wingId) {
        const wing = this.wings.find(x => x.id === this.wingId);
        this.preview = wing?.backgroundImage ?? '';
        this.$emit('changeBackgroundImage', this.preview);
      }
    },
    async changeBorderPerWing() {
      this.disabled = false;

      this.resetSettingsParams();

      await this.updateFacilityDifferentWings(this.isHaveDifferentBorderPerWing);

      if(!this.isHaveDifferentBorderPerWing) {
        this.preview = this.facility?.printableCalendarUrl;
        this.$emit('changeBackgroundImage', this.facility?.printableCalendarUrl);
        this.removeAbilityToExport();
      } else {
        const wing = this.wings.find(x => x.id === this.wingId);
        this.$emit('changeBackgroundImage', wing?.backgroundImage);
        this.changeWing();
      }
    },
    async cancelChangesPrintableCalendar() {
      await this.$store.dispatch("getEventWings")
      this.checkFacilityPrintableCalendarSettings();
      this.checkFacilityPrintableCalendarFonts();
      this.checkFacilityHaveDifferentBorderPerWing();
      this.changeBorderPerWing();
      this.$emit('changeBackgroundColor', this.color);
      this.$emit('addAbilityToExport');
    },
    removeAbilityToExport() {
      this.$emit('removeAbilityToExport');
    },
    async updateFacilityDifferentWings(value) {
      return await firebase
        .firestore()
        .collection('facility')
        .doc(this.facilityId)
        .update({
          isHaveDifferentBorderPerWing: value,
        }).then(async () => {
          return await this.$store.dispatch("getFacility")
      })
    },
    resetSettingsParams() {
      this.isUploadGalleryPhoto = false;
      this.isChangePhoto = false;
      this.isChangeColor = false;
      this.isRemovePhoto = false;
      this.isChangeHeader = false;
      this.isChangeBody = false;
      this.isChangedBorderForWing = false;
      this.isChangePrintableCalendarBodyFontSize = false;
      this.isChangePrintableCalendarHeaderFontSize = false;
      this.isChangePrintableCalendarLocationKeysSize = false;
      this.isChangePrintableCalendarHideLocationKeys = false;
      this.isChangePrintableCalendarDatesBackgroundColor = false;
      this.isChangePrintableCalendarDatesColor = false;
    },
    handleClick(index) {
      const refName = `image${index}`;
      const inputRef = this.$refs[refName];
      if (inputRef[0]) {
        inputRef[0].click();
      }
    },
    addNewImage() {
      this.$emit("addNewImage");
    },
    addNewTextBox() {
      this.$emit("addNewTextBox");
    },
    mapPrintableCalendarImages() {
      this.printableCalendarImages = this.printableCalendarImages.map(x => {
        return {
          url: x.url,
          page: x.page,
          week: x.week,
          position: x.position
        }
      });
    },
    customTextBoxSwatchStyle(color) {
      return {
        backgroundColor: color,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: '100%',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    onInputWingsCustomNameDescription() {
      this.$emit('setWingsCustomNameDescription', this.wingsCustomNameDescription)
    },
  },
  watch: {
    selectedWingsPrintableCalendar(newValue) {
      if(!this.isHaveDifferentBorderPerWing || !newValue.length) {
        this.preview = this.facility?.printableCalendarUrl;
        this.$emit('changeBackgroundImage', this.facility?.printableCalendarUrl);
      } else {
        if(newValue && newValue.length && newValue.find(x => x.backgroundImage)) {
          this.wingId = newValue[newValue?.length - 1].id;
          this.changeWing();
        }

        if(newValue?.length === this.wings?.length) {
          this.wingId = newValue[newValue?.length - 1].id;
          this.preview = this.wings.find(x => x.id === newValue[newValue?.length].id)?.backgroundImage ?? '';
        }
      }
    },
    printableCalendarHeaderFont(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeHeaderFonts', newValue);
        this.removeAbilityToExport();
        this.isChangeHeader = true;
        this.disabled = false;
      }
    },
    isChangePrintableCalendarHeaderFontColor(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeHeaderFontColor', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarHeaderFontColor = true;
        this.disabled = false;
      }
    },
    isChangePrintableCalendarInputCustomBoxColor(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeInputCustomBoxColor', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarInputCustomBoxColor = true;
        this.disabled = false;
      }
    },
    printableCalendarHeaderFontSize(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeHeaderFontsSize', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarHeaderFontSize = true;
        this.disabled = false;
      }
    },
    printableCalendarBodyFont(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeBodyFonts', newValue);
        this.removeAbilityToExport();
        this.isChangeBody = true;
        this.disabled = false;
      }
    },
    printableCalendarBodyFontSize(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeBodyFontsSize', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarBodyFontSize = true;
        this.disabled = false;
      }
    },
    printableCalendarLocationKeysFontSize(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeLocationKeysFontSize', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarLocationKeysSize = true;
        this.disabled = false;
      }
    },
    printableCalendarHideLocationKeys(newValue, oldValue) {
      if(newValue !== oldValue) {
        this.$emit('changeLocationKeys', newValue);
        this.removeAbilityToExport();
        this.isChangePrintableCalendarHideLocationKeys = true;
        this.disabled = false;
      }
    },
    printableCalendarInputCustomBoxSize(newValue, oldValue) {
      if(oldValue && newValue !== oldValue) {
        this.$emit('changeInputCustomBoxSize', newValue);
        this.removeAbilityToExport();
        this.isChangedCustomTextBoxSize = true;
        this.disabled = false;
      }
    },
    isHaveDifferentBorderPerWing() {
      this.isChangedBorderForWing = true;
    },
    isDimensionColor(newValue) {
      this.$emit('changeDisplayDimensionColor', newValue);
      this.isChangedDimensionColor = true;
      this.disabled = false;
    },
    isUseWingsCustomName(newValue) {
      this.$emit('changeDisplayWingsCustomName', newValue);
      this.isChangedUseWingsCustomName = true;
      this.disabled = false;
    },
    isUseFacilityCustomName(newValue) {
      this.$emit('changeFacilityCustomName', newValue);
      this.isChangedUseFacilityCustomName = true;
      this.disabled = false;
    },
    wingsCustomNameDescription(value) {
      this.isChangedUseWingsCustomNameDescription = true;
      this.disabled = false;
    },
    facilityCustomName(value) {
      this.isChangedFacilityCustomName = true;
      this.disabled = false;
    },
    selectedDimensionColorType(value) {
      this.$emit('changeDimensionColorType', value);
      this.isChangedDimensionColorType = true;
      this.disabled = false;
    },
    weekdays() {
      this.isChangedWeekdays = true;
      this.disabled = false;
    },
    isCompactMode() {
      this.isChangedCompactMode = true;
      this.disabled = false;
    },
    isShowConciergeEvents() {
      this.isChangedConciergeEvents = true;
      this.disabled = false;
    },
    isShowEndTime() {
      this.isChangedShowEndTime = true;
      this.disabled = false;
    },
    isDatePositionRight() {
      this.isChangedDatePositionRight = true;
      this.disabled = false;
    },
    isDisplayAMPM() {
      this.isChangedDisplayAMPM = true;
      this.disabled = false;
    },
    calendarDescription() {
      this.isChangedCalendarDescription = true;
      this.disabled = false;
    },
    locationsSizeHeader: {
      handler() {
        this.isChangedLocationsHeaderSize = true;
        this.disabled = false;
      },
      deep: true
    },
    customTextBoxSizeHeader: {
      handler() {
        this.isChangedCustomTextBoxColor = true;
        this.disabled = false;
      },
      deep: true
    },
    decorImageSize: {
      handler() {
        this.isChangedDecorImageSize = true;
        this.disabled = false;
      },
      deep: true
    },
    logoSize: {
      handler() {
        this.isChangedLogoSize = true;
        this.disabled = false;
      },
      deep: true
    },
    customPhotoSize: {
      handler() {
        this.isChangedCustomImageSize = true;
        this.disabled = false;
      },
      deep: true
    },
    printableCalendarImages: {
      handler() {
        this.isChangedImagesPositions = true;
        this.disabled = false;
      },
      deep: true
    },
    printableCalendarTextBoxes: {
      handler() {
        this.isChangedTextBoxes = true;
        this.disabled = false;
      },
      deep: true
    }
  }
}